import {lazy} from 'react';

export const StickyColumnLazy = lazy(() => import(/* webpackChunkName: "stickyColumn" */ '.'));
